import EventParams from '../interfaces/EventParams';

// Products

export const CROP_MONITORING = 'Crop-Monitoring';
export const LAND_VIEWER = 'LandViewer';
export const FORESTRY = 'Forestry';

// Payment types
const Charge = 'Charge';
const Group = 'Group';
const Trial = 'Trial';
const Staff = 'Staff';
export const NGO = 'NGO';
export const INVOICE = 'Invoice';
export const PAYMENT_TYPES = [INVOICE, NGO, Group, Charge, Trial, Staff];

// Packages
export const PACKAGE_INDIVIDUAL = 'Individual';
export const PACKAGE_PROFESSIONAL = 'professional';

// Form params
export const PRODUCT = 'product';
export const PACKAGE = 'package_';
export const DATE_TO = 'dateTo';
export const DATE_FROM = 'dateFrom';
export const TYPE_PAYMENT = 'typePayment';
export const PLANE_PRICE = 'planPrice';
export const FIELDS_AREA = 'fieldsArea';

// Сurrencies
export const USD = 'USD';

// Messages
export const FAILED = 'FAILED';

export const SUBSCRIPTION_MESSAGE = {
  edit: {
    success: 'SUBSCRIPTION SUCCESSFULLY EDITED',
    fail: 'SUBSCRIPTION FAILED TO EDIT',
  },
  delete: {
    success: 'SUBSCRIPTION SUCCESSFULLY CLOSED',
    fail: 'SUBSCRIPTION FAILED TO CLOSE',
  },
  add: {
    success: 'SUBSCRIPTION SUCCESSFULLY ADDED',
    fail: 'SUBSCRIPTION FAILED TO ADD',
  },
  loadExist: {
    warning: 'USER DOES NOT HAVE EXISTING SUBSCRIPTIONS',
  },
  refreshToken: {
    success: 'TOKEN WAS SUCCESSFULLY REFRESHED',
    fail: 'TOKEN FAILED TO REFRESH',
  },
};

export const MESSAGE_TYPE = {
  success: 'Success',
  fail: 'Fail',
  warning: 'Warning',
};

// Error constants
export const INVALID_DATE_RANGE = 'Invalid period of time. Please choose another date';
export const CHANGE_DATE_FROM_FAIL = 'Subscription always starts by current day';
export const INVALID_NUMBER_INPUT = 'Please enter valid number';

// Snackbar
export const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'right',
};

const NOT_SET = '(not set)';

export const initParams: EventParams = {
  event: 'EOSCOM',
  eventCategory: 'AgroDesktop',
  eventAction: 'click',
  eventLabel: 'UsercardPlanActivate',
  eventContent: '0',
  eventContext: 'Invoice',
  eventPosition: NOT_SET,
  eventLocation: NOT_SET,
};
